import { graphql } from "gatsby";
import React from "react";

import { ServiceLanguages } from "../../../company/settings/translations";
import Layout from "../modules/Layout/Layout";
import { SEO } from "../modules/SEO/SEO";
import { getSlugWithLang } from "../modules/shared/utils/getSlugWithLang";
import { HeroContact } from "../sections/HeroContact/HeroContact";
import { SectionFaqs } from "../sections/SectionFaqs/SectionFaqs";
import { ILink, IPageProps } from "../types/thecookies";

const ContactTemplate = ({ data, pageContext }: IPageProps<Queries.ContactTemplateQuery>) => {
  const menu: ILink[] = [
    { name: data.home?.name, slug: "/" },
    {
      name: ServiceLanguages[pageContext.language].name,
      slug: `/#${ServiceLanguages[pageContext.language].name}`,
    },
    { name: data.projects?.name, slug: data.projects?.slug?.current },
  ];

  return (
    <Layout
      lang={pageContext.language}
      navbarLinks={menu}
      settings={data.settings}
      landingName={"contact"}
      legalLinks={data.legals.nodes.map((node) => {
        return {
          slug: getSlugWithLang(`/legal/${node.slug?.current}`, pageContext.language),
          name: node.name,
        };
      })}
    >
      <HeroContact data={data.page?.heroContact as Queries.SanityHeroContact} />
      <SectionFaqs data={data.home?.sectionFaqs as Queries.SanityFaqs} />
    </Layout>
  );
};

export default ContactTemplate;

export const Head = ({ data, pageContext }: IPageProps<Queries.ContactTemplateQuery>) => (
  <SEO
    metas={{
      seo: data.page?.seo as Queries.SanitySeoTags,
      language: pageContext.language,
      slug: data.page?.slug?.current,
      hrefLangList: data.hrefLangList.nodes,
    }}
  />
);

export const query = graphql`
  query ContactTemplate($language: String = "es") {
    page: sanityContact(language: { eq: $language }) {
      ...seo
      slug {
        current
      }
      heroContact {
        resume {
          ...resume
        }
        listContact
      }
    }
    home: sanityHome(language: { eq: $language }) {
      name
      sectionFaqs {
        title
        faqsList {
          answer
          question
        }
      }
    }
    hrefLangList: allSanityContact {
      nodes {
        language
        slug {
          current
        }
      }
    }
    contact: sanityContact(language: { eq: $language }) {
      ...menu
    }
    projects: sanityIndexOfProjects(language: { eq: $language }) {
      ...menu
    }
    legals: allSanityLegal(filter: { language: { eq: $language } }) {
      nodes {
        name
        slug {
          current
        }
      }
    }
    settings: sanitySetting {
      postalAddress {
        address
      }
      email
      phone
    }
  }
`;
